import React from "react";
import {
  Route,
  Switch,
  useHistory,
  Link,
  NavLink,
  useRouteMatch,
} from "react-router-dom";
import { usePermissionsContext } from "../../context/contextPermissions";
import { deleteStudy } from "../../services/apis";

import Hedonic from "./Hedonic";
import Perception from "./Perception";

import "./Study.css";

export default function Study({ study, curCandidate }) {
  const { permissions, setPermissions } = usePermissionsContext();
  const history = useHistory();
  const [displayInformationsBlock, setDisplayInformationsBlock] = React.useState(false);
  const [deleteStatus, setDeleteStatus] = React.useState({
    status: "",
    message: "",
  });

  let { path, url } = useRouteMatch();
  var hedonic;
  var perception;
  var metadata;

  if (study.length !== 0) {
    hedonic = study[0].Hedonic;

    if (curCandidate !== 'candidate') {
      hedonic.Result.forEach(function (item, i) {
        if (item.Product == curCandidate) {
          hedonic.Result.splice(i, 1);
          hedonic.Result.unshift(item);
        }
      });
    }

    perception = JSON.parse(JSON.stringify(study[0].Perception));
    perception.Scatter_plot = study[0].Hedonic.Scatter_plot;
    metadata = study[0].Metadata;
  } else {
    window.location.href = "/";
  }

  async function onDelete(e) {
    e.preventDefault();

    const data = {
      "study_id": metadata.Study_number,
      "country": metadata.Country,
      "client": metadata.Client,
      "gender": metadata.Gender,
    };

    try {
      const jwt = localStorage.getItem("jwt");
      var deleteStudyResult = await deleteStudy(jwt, data);
      setDeleteStatus({ status: "success", message: deleteStudyResult.message });
      setDisplayInformationsBlock(true);
      setTimeout(() => { history.push("/search") }, 3000);
    } catch (ex) {
      if (ex && ex.response && ex.response.data && ex.response.data.message) {
        setDeleteStatus({ status: "error", message: ex.response.data.message });
        setDisplayInformationsBlock(true);
      }
    }
  };

  return (
    <>
      <div className="tabs">
        <NavLink activeClassName="tab--active" to={`${url}/hedonic`}>
          Hedonic
        </NavLink>
        <NavLink activeClassName="tab--active" to={`${url}/perception`}>
          Perception
        </NavLink>
      </div>

      {displayInformationsBlock ? (
        <div
          className={
            deleteStatus.status == "error" ? "block error" : "block success"
          }
        >
          <div className="errorBlock__content">
            <div className="errorBlock__iconContainer">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="info"
                className="svg-inline--fa fa-info fa-w-6 "
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 192 512"
              >
                <path
                  fill="currentColor"
                  d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                ></path>
              </svg>
            </div>
            <div className="errorBlock__container">
              <div className="errorBlock__title">info</div>
              <div className="errorBlock__message"> {deleteStatus.message}</div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      {permissions.admin_panel == true &&
        <button
          className="btn btn__delete"
          onClick={onDelete}
        >
          Delete this study
        </button>
      }

      <div className="studyInfos">
        <div className="studyInfos__box">
          <span className="studyInfos__title">Study Nº:</span>
          <span className="studyInfos__value">{metadata.Study_number}</span>
        </div>
        <div className="studyInfos__box">
          <span className="studyInfos__title">Client:</span>
          <span className="studyInfos__value">{metadata.Client}</span>
        </div>
        <div className="studyInfos__box">
          <span className="studyInfos__title">Country:</span>
          <span className="studyInfos__value">{metadata.Country}</span>
        </div>
        <div className="studyInfos__box">
          <span className="studyInfos__title">Gender:</span>
          <span className="studyInfos__value">{metadata.Gender}</span>
        </div>
        <div className="studyInfos__box">
          <span className="studyInfos__title">Method:</span>
          <span className="studyInfos__value">{metadata.Method}</span>
        </div>
        <div className="studyInfos__box">
          <span className="studyInfos__title">Number of Fragrances:</span>
          <span className="studyInfos__value">
            {metadata.Number_of_fragrances}
          </span>
        </div>
      </div>

      <Route
        exact
        path={`${path}/hedonic`}
        component={() => <Hedonic hedonic={hedonic} metadata={metadata} curCandidate={curCandidate} />}
      />
      <Route
        exact
        path={`${path}/perception`}
        component={() => (
          <Perception perception={perception} metadata={metadata} />
        )}
      />
    </>
  );
}
